/**
 * PROTOTYPE staff art (วิชาไม้พลอง) of the new sect คลื่นไผ่ (docs/design/combat/2026-10-11-weapon-arts.md §2, balance R7).
 * Rules and numbers only: no FX, sound or motion of its own (the `fx` ids reuse existing ones). HIDDEN from players: not in the
 * starting kit, not teachable, not in a shop (`hidden`), until the staff phase of the plan is built; the sims reach it by id.
 *
 * Names are WORKING names, TODO-IP: ns-ip checks, ns-wuxia renames (copyright first). The move set follows the rule: one lock
 * (tt-pin), one guard buff (tt-ward: arms 8 s, a blocked blow grants tide-surge, the next sweep strikes harder; data/guardBuffs.ts), one break (tt-ankle), one ท่าใหญ่ (tt-tide), plus a poke, a ring, a closer and a three-cut string.
 */
import type { MartialArtDef, SkillDef } from './skills';

export const STAFF_ART = 'tide-staff';

export const STAFF_SKILLS: readonly SkillDef[] = [
  {
    id: 'tt-wave', // TODO-IP
    name: 'พลองกวาดคลื่น',
    glyph: '浪',
    kind: 'attack',
    qi: 12,
    cooldown: 3,
    windup: 0.15,
    range: 2.9,
    power: 1.24,
    empoweredBy: { status: 'tide-surge', bonus: 0.6 },
    fx: 'wind',
    desc: 'กวาดพลองเป็นวงกว้างระยะ 2.9 ช่อง ถ้ามีคลื่นหนุนจะแรงขึ้นอีกเท่าหนึ่ง',
  },
  {
    id: 'tt-ankle', // TODO-IP
    name: 'พลองกวาดข้อเท้า',
    glyph: '絆',
    kind: 'break',
    qi: 0,
    cooldown: 1,
    windup: 0.55,
    range: 2.4,
    power: 1.14,
    stun: 1.8,
    fx: 'crush',
    desc: 'กวาดพลองต่ำสะดุดข้อเท้า ชาร์จครึ่งวินาที หากศัตรูตั้งรับ การ์ดแตกและล้มมึน',
  },
  {
    id: 'tt-whirl', // TODO-IP
    name: 'พลองหมุนน้ำวน',
    glyph: '渦',
    kind: 'attack',
    qi: 20,
    cooldown: 7,
    windup: 0.2,
    range: 0,
    power: 0.99,
    aoe: 2.8,
    fx: 'whirl',
    desc: 'หมุนพลองรอบตัวครบวง ตีทุกตัวในรัศมี 2.8 ช่อง',
  },
  {
    id: 'tt-vault', // TODO-IP
    name: 'ค้ำพลองข้ามคลื่น',
    glyph: '越',
    kind: 'attack',
    qi: 20,
    cooldown: 9,
    windup: 0.15,
    range: 5,
    power: 0.86,
    dash: 'target',
    fx: 'pierce',
    desc: 'ปักพลองค้ำตัวพุ่งเข้าหาศัตรูในระยะ 5 ช่อง แล้วฟาดทันที',
  },
  {
    id: 'tt-pin', // TODO-IP
    name: 'พลองกดตรึงคลื่น',
    glyph: '壓',
    kind: 'attack',
    qi: 22,
    cooldown: 7,
    windup: 0.45,
    range: 2.8,
    power: 0.47,
    hits: 3,
    fx: 'chain',
    desc: 'ท่าล็อกตัว ล็อกเป้าหมายแล้วใช้ปลายพลองกดตรึงจนล้ม',
  },
  {
    id: 'tt-ripple', // TODO-IP
    name: 'คลื่นซัดสามชั้น',
    glyph: '波',
    kind: 'attack',
    qi: 18,
    cooldown: 5,
    windup: 0.2,
    range: 5,
    ground: true,
    land: 0.5,
    aoe: 2.4,
    power: 0.47,
    hits: 3,
    fx: 'chain',
    desc: 'ฟาดพลองต่อเนื่องสามครั้งดุจคลื่นซ้อนคลื่น',
  },
  {
    id: 'tt-ward', // TODO-IP
    name: 'พลองหมุนกั้นคลื่น',
    glyph: '禦',
    kind: 'buff',
    qi: 0,
    cooldown: 12,
    windup: 0,
    range: 0,
    power: 0,
    self: { status: 'tide-ward' },
    fx: 'aura',
    desc: 'ท่าตั้งรับของพลอง (ท่าหนุนการ์ด) ตั้งการ์ดรอ 8 วินาที ถ้ารับท่าได้จะได้คลื่นหนุน ท่ากวาดคลื่นครั้งถัดไปแรงขึ้น',
  },
  {
    id: 'tt-tide', // TODO-IP
    name: 'คลื่นไผ่ท่วมฟ้า',
    glyph: '潮',
    kind: 'power',
    qi: 0,
    cooldown: 12,
    windup: 0.6,
    range: 0,
    power: 0.52,
    rage: 10,
    aoe: 3.2,
    hits: 3,
    hitStun: 1,
    fx: 'whirl',
    desc: 'ท่าใหญ่ ใช้ความโกรธ 10 หมุนพลองเป็นคลื่นซัดสามระลอกรอบตัว ศัตรูโดยรอบมึน 1 วินาที ตั้งรับไม่ได้',
  },
];

export const STAFF_ART_DEF: MartialArtDef = {
  id: STAFF_ART,
  hidden: true,
  name: 'ไม้พลองคลื่นไผ่', // TODO-IP
  school: 'คลื่นไผ่',
  weapon: 'staff',
  element: 'soft',
  damage: 'external',
  desc: 'วิชาไม้พลองของสำนักคลื่นไผ่ (ต้นแบบ ยังไม่เปิดให้ผู้เล่น) ระยะยาวกว่ากระบี่ กวาดวงกว้าง จุดอ่อนคือระยะประชิดหลังพลาด',
  skills: STAFF_SKILLS.map((s) => s.id),
  basic: { power: 0.86, range: 2.7, rate: 0.75 },
};
